// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UEqL","label":"styles_label__18d79"};